import { Theme } from './types';

const colors = {
  // TODO: deprecate eventually
  neutral: {
    '000': '#ffffff',
    '100': '#f1f3f5',
    '200': '#e9ecef',
    '300': '#dee2e6',
    '400': '#ced4da',
    '500': '#adb5bd',
    '600': '#868e96',
    '700': '#495057',
    '800': '#343a40',
    '900': '#212529',
    '1000': '#000000'
  },

  black: '#000000',
  white: '#ffffff',

  grey: {
    '100': '#f3f3f3',
    '200': '#dedede',
    '300': '#c7c7c7',
    '400': '#a7a7a7',
    '500': '#858585',
    '600': '#656565',
    '700': '#525252',
    '800': '#3f3f3f',
    '900': '#333333',
    '1000': '#232323'
  },

  red: {
    '000': '#9a3324',
    '100': '#faf1f0',
    '200': '#f9d3cd',
    '300': '#f8b5ab',
    '400': '#f98776',
    '500': '#dc6350',
    '600': '#ac493a',
    '700': '#963627',
    '800': '#75291e',
    '900': '#5b231a',
    '1000': '#2e1f1d'
  },

  orange: {
    '000': '#e87722',
    '100': '#fcf1e8',
    '200': '#fbd7bc',
    '300': '#f5bb8e',
    '400': '#eb9452',
    '500': '#c97230',
    '600': '#975726',
    '700': '#7b4821',
    '800': '#5b381d',
    '900': '#4b2a11',
    '1000': '#342011'
  },

  yellow: {
    '000': '#ffc72c',
    '100': '#fbf4df',
    '200': '#f6de9c',
    '300': '#edc75e',
    '400': '#d2a732',
    '500': '#a78322',
    '600': '#876508',
    '700': '#675218',
    '800': '#4e3e13',
    '900': '#403310',
    '1000': '#2b230e'
  },

  green: {
    '000': '#67823a',
    '100': '#ecf8d8',
    '200': '#d8eaa9',
    '300': '#b8dc7f',
    '400': '#94bf4f',
    '500': '#799749',
    '600': '#5b7038',
    '700': '#4b5f2b',
    '800': '#364918',
    '900': '#2c361d',
    '1000': '#1f2811'
  },

  blue: {
    '000': '#4f758b',
    '100': '#f0f6fa',
    '200': '#cfe2ed',
    '300': '#aecee0',
    '400': '#81b3cf',
    '500': '#5f8fab',
    '600': '#476e85',
    '700': '#3a586a',
    '800': '#2b4555',
    '900': '#243641',
    '1000': '#1a262d'
  },

  purple: {
    '000': '#5f249f',
    '100': '#f5f0fa',
    '200': '#e7d7f9',
    '300': '#d5b9f3',
    '400': '#b992e3',
    '500': '#9f6cd5',
    '600': '#7e49b7',
    '700': '#653e8e',
    '800': '#4e316e',
    '900': '#3e245a',
    '1000': '#2b1a3d'
  }
};

// NOTE: https://www.modularscale.com/
const fontSizes = {
  '100': '8px',
  '200': '10px',
  '250': '11px',
  '300': '12px',
  '400': '14px',
  '500': '16px',
  '600': '20px',
  '700': '24px',
  '800': '30px',
  '900': '36px'
};

const fontWeights = {
  '100': 100,
  '200': 200,
  '300': 300,
  '400': 400,
  '500': 500,
  '600': 600,
  '700': 700,
  '800': 800,
  '900': 900
};

const radii = {
  '100': '2px',
  '200': '4px',
  '300': '6px',
  '400': '8px',
  '500': '10px',
  '600': '12px',
  '700': '14px',
  '800': '16px',
  // NOTE: 900 is special in that is percentage based e.g. full roundness
  '900': '50%'
};

// NOTE: Spacing scales are tricky, as you can see the gap between spaces increases
// exponentially after 500 as generally anything outside of 400 or 500
// would be considered an extreme use case
const spacings = {
  // NOTE: We have a special intensity value here of `000` to denote no spacing
  '000': '0px',
  '100': '2px',
  '200': '4px',
  '300': '6px',
  '400': '8px',
  '450': '12px',
  '500': '16px',
  '550': '20px',
  '600': '24px',
  '700': '32px',
  '800': '48px',
  '900': '64px'
};

const fontFamilies = {
  mono: 'Fira Code',
  sansSerif: 'GraphikCompact, system',
  serif: 'serif'
};

export const theme: Theme = {
  colors,
  fontSizes,
  fontWeights,
  fontFamilies,
  radii,
  spacings
};
